import { cn } from '@lib/utils';

type CyberQuestionContextComponentProps = {
  className?: string;
  contentClassName?: string;
  missionImpactIfNo?: string;
  title?: string;
};

const MISSION_IMPACT_PREFIX_PATTERN = /^mission impact if no:\s*/i;

const parseMissionImpactIfNo = (
  missionImpactIfNo?: string,
): {
  detail?: string;
  label?: string;
} => {
  const normalizedMissionImpact = missionImpactIfNo?.replace(MISSION_IMPACT_PREFIX_PATTERN, '').trim();

  if (!normalizedMissionImpact) {
    return {};
  }

  const separatorIndex = normalizedMissionImpact.indexOf(':');

  if (separatorIndex <= 0 || separatorIndex === normalizedMissionImpact.length - 1) {
    return {
      detail: normalizedMissionImpact,
    };
  }

  return {
    detail: normalizedMissionImpact.slice(separatorIndex + 1).trim(),
    label: normalizedMissionImpact.slice(0, separatorIndex).trim(),
  };
};

export const CyberQuestionContextComponent: React.FC<CyberQuestionContextComponentProps> = (props) => {
  const { className, contentClassName, missionImpactIfNo, title = 'Why It Matters' } = props;
  const { detail, label } = parseMissionImpactIfNo(missionImpactIfNo);
  const shouldShowMissionImpact = Boolean(detail || label);

  if (!shouldShowMissionImpact) {
    return null;
  }

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <div className="text-sm font-semibold text-rose-600">{title}</div>
      <div className={cn('text-xs leading-relaxed text-slate-600', contentClassName)}>
        {label ? <span className="font-semibold text-slate-800">{label}: </span> : null}
        {detail}
      </div>
    </div>
  );
};
